import _objectSpread from "/Users/liuli/Documents/hu/riscern-pc-ui/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/Users/liuli/Documents/hu/riscern-pc-ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-443533fa"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "content"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title"
  }, "Subscriptions Information", -1);
});

import { onMounted, ref } from 'vue';
import { apiGetCurrentSubscribe, apiGetUserCard } from '@/api/information';
import { apiGetPrice } from '@/api/common';
import { DATA_TYPE } from '@/utils/constData';
import { apiGetUser } from '@/api/login';
import UpdateDialog from './UpdateDialog.vue';
import Pro from './Pro/index.vue';
import Deep from './Deep/index.vue';
import Free from './Free.vue';
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var currentData = ref({});
    var userCardData = ref({});
    var pageLoading = ref(true); // 默认页面loading

    function getCurrentSubscribe() {
      return _getCurrentSubscribe.apply(this, arguments);
    }

    function _getCurrentSubscribe() {
      _getCurrentSubscribe = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var currentRes, resultData, _ref2, subscribeStatus, userCardRes;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                pageLoading.value = true;
                _context.next = 3;
                return apiGetCurrentSubscribe();

              case 3:
                _context.t0 = _context.sent;

                if (_context.t0) {
                  _context.next = 6;
                  break;
                }

                _context.t0 = {};

              case 6:
                currentRes = _context.t0;
                _context.next = 9;
                return apiGetUser();

              case 9:
                resultData = _context.sent;
                currentData.value = _objectSpread(_objectSpread({}, currentRes.data), {}, {
                  vipType: resultData.data.vipType
                });
                _ref2 = currentRes.data || {}, subscribeStatus = _ref2.subscribeStatus; // 存在并且不是 已失效状态

                if (!(subscribeStatus && subscribeStatus !== 3)) {
                  _context.next = 17;
                  break;
                }

                _context.next = 15;
                return apiGetUserCard();

              case 15:
                userCardRes = _context.sent;
                userCardData.value = userCardRes.data || {};

              case 17:
                pageLoading.value = false;

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _getCurrentSubscribe.apply(this, arguments);
    }

    var initData = ref({});
    onMounted(function () {
      getCurrentSubscribe();
      apiGetPrice().then(function (_ref) {
        var data = _ref.data;
        initData.value = data;
      });
    });
    return function (_ctx, _cache) {
      var _directive_loading = _resolveDirective("loading");

      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, !pageLoading.value ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [currentData.value.vipType === _unref(DATA_TYPE).PRO ? (_openBlock(), _createBlock(Pro, {
        key: 0,
        currentData: currentData.value,
        userCardData: userCardData.value,
        initData: initData.value
      }, null, 8, ["currentData", "userCardData", "initData"])) : currentData.value.vipType === _unref(DATA_TYPE).DEEP ? (_openBlock(), _createBlock(Deep, {
        key: 1,
        currentData: currentData.value,
        userCardData: userCardData.value,
        initData: initData.value
      }, null, 8, ["currentData", "userCardData", "initData"])) : (_openBlock(), _createBlock(Free, {
        key: 2,
        currentData: currentData.value
      }, null, 8, ["currentData"]))], 64)) : _createCommentVNode("", true), _createVNode(UpdateDialog, {
        onGetData: getCurrentSubscribe
      })])), [[_directive_loading, pageLoading.value]]);
    };
  }
});